import { render, staticRenderFns } from "./podgrupe-vozila.editor.vue?vue&type=template&id=61588e44&scoped=true&"
import script from "./podgrupe-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./podgrupe-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61588e44",
  null
  
)

export default component.exports